import * as types from './constants';

// Get Discover Categories
export const getDiscoverCategoriesRequest = data => (
  { type: types.GET_DISCOVER_CATEGORIES_REQUEST, payload: data }
);

export const getDiscoverCategoriesDone = data => (
  { type: types.GET_DISCOVER_CATEGORIES_DONE, payload: data }
);

export const getDiscoverCategoriesFailed = errors => (
  { type: types.GET_DISCOVER_CATEGORIES_FAILED, payload: errors }
);

export const getDiscoverCategoriesReset = () => (
  { type: types.GET_DISCOVER_CATEGORIES_RESET }
);

// Operations

export const discoverCategoriesSetPage = data => (
  { type: types.DISCOVER_CATEGORIES_SET_PAGE, payload: data }
);